import { Link } from "react-router-dom";

const QUICK_LINKS = [
  { to: "/services", label: "Services" },
  { to: "/fleet", label: "Fleet" },
  { to: "/about", label: "About" },
  { to: "/faq", label: "FAQ" },
  { to: "/contact", label: "Contact" },
];

const SERVICE_AREAS = [
  "Sydney CBD",
  "Sydney Airport",
  "Eastern Suburbs",
  "North Shore",
  "Inner West",
  "Northern Beaches",
];

export default function Footer() {
  const year = new Date().getFullYear();

  return (
    <footer
      data-testid="global-footer"
      className="bg-near-black text-warm-white border-t border-white/10"
    >
      <div className="max-w-[92rem] mx-auto px-6 lg:px-12 pt-24 pb-12">
        {/* Top statement */}
        <div className="grid lg:grid-cols-12 gap-14 lg:gap-16 pb-16 border-b border-white/10">
          <div className="lg:col-span-5">
            <div className="flex items-center gap-3.5">
              <span className="w-10 h-10 grid place-items-center border border-gold/40/60 text-warm-white text-[13px] tracking-[0.15em] font-medium">
                SJ
              </span>
              <span
                className="text-warm-white text-[14px] tracking-[0.28em] uppercase font-medium"
                style={{ fontFamily: "Manrope, sans-serif" }}
              >
                Sydney James
              </span>
            </div>
            <p
              className="mt-8 text-warm-white/70 text-lg md:text-xl leading-[1.55] max-w-md"
              style={{ fontFamily: "Cormorant Garamond, serif", fontStyle: "italic" }}
            >
              Private chauffeur travel, precisely handled — across Sydney, its airports and surrounding regions.
            </p>
            <Link
              to="/book"
              data-testid="footer-cta-book"
              className="mt-10 inline-flex items-center gap-3 border border-gold/40 text-warm-white px-6 py-3 text-[11px] tracking-[0.28em] uppercase font-medium transition-all duration-500 hover:border-gold hover:bg-gold/[0.05]"
            >
              <span>Book Your Journey</span>
              <span className="w-1.5 h-1.5 rounded-full bg-gold" />
            </Link>
          </div>

          <div className="lg:col-span-2">
            <p className="sjc-eyebrow text-warm-white/60">Explore</p>
            <ul className="mt-6 space-y-3.5">
              {QUICK_LINKS.map((l) => (
                <li key={l.to}>
                  <Link
                    to={l.to}
                    data-testid={`footer-link-${l.label.toLowerCase()}`}
                    className="text-warm-white/75 text-sm hover:text-warm-white transition-colors duration-300"
                  >
                    {l.label}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          <div className="lg:col-span-2">
            <p className="sjc-eyebrow text-warm-white/60">Service Area</p>
            <ul className="mt-6 space-y-3.5">
              {SERVICE_AREAS.map((a) => (
                <li key={a} className="text-warm-white/60 text-sm">
                  {a}
                </li>
              ))}
            </ul>
          </div>

          <div className="lg:col-span-3">
            <p className="sjc-eyebrow text-warm-white/60">Concierge</p>
            <div className="mt-6 space-y-5">
              <div>
                <p className="text-[10px] tracking-[0.28em] uppercase text-warm-white/35 font-medium">
                  Reservations
                </p>
                <a
                  data-testid="footer-contact-phone"
                  href="tel:+61400000000"
                  className="mt-1.5 block text-warm-white text-lg font-display tracking-tight hover:text-gold transition-colors duration-300"
                >
                  +61 400 000 000
                </a>
              </div>
              <div>
                <p className="text-[10px] tracking-[0.28em] uppercase text-warm-white/35 font-medium">
                  Correspondence
                </p>
                <a
                  data-testid="footer-contact-email"
                  href="mailto:info@sydneyjames.com.au"
                  className="mt-1.5 block text-warm-white text-sm hover:text-gold transition-colors duration-300 break-all"
                >
                  info@sydneyjames.com.au
                </a>
              </div>
              <div>
                <p className="text-[10px] tracking-[0.28em] uppercase text-warm-white/35 font-medium">
                  Availability
                </p>
                <p className="mt-1.5 text-warm-white/75 text-sm">
                  24 hours · Every day
                </p>
              </div>
            </div>
          </div>
        </div>

        <div className="pt-8 flex flex-col md:flex-row md:items-center md:justify-between gap-4 text-[11px] tracking-[0.2em] uppercase text-warm-white/40 font-medium">
          <p data-testid="footer-copyright">© {year} Sydney James Chauffeurs</p>
          <div className="flex flex-wrap gap-x-8 gap-y-2">
            <Link to="/faq" className="hover:text-warm-white/80 transition-colors">
              Frequently Asked
            </Link>
            <Link to="/contact" className="hover:text-warm-white/80 transition-colors">
              Enquiries
            </Link>
            <span>Sydney, Australia</span>
          </div>
        </div>
      </div>
    </footer>
  );
}
